import { Button } from "@gigpro/ui/Button";
import { Dialog, DialogFooter, DialogTitle } from "@gigpro/ui/Dialog";

type DeleteConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  title?: string;
  content: React.ReactNode;
  cancelLabel?: string;
  deleteLabel?: string;
  isPending?: boolean;
};

export const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  onClose,
  onDelete,
  title: titleSection = "Are you sure?",
  content,
  cancelLabel = "Cancel",
  deleteLabel = "Delete",
  isPending = false,
}) => (
  <Dialog open={open} onClose={onClose} bottomSheet>
    <DialogTitle>{titleSection}</DialogTitle>
    <p className="text-wrap">{content}</p>
    <DialogFooter>
      <Button onClick={onClose} className="w-full" disabled={isPending}>
        {cancelLabel}
      </Button>
      <Button onClick={onDelete} className="w-full" variant="destructive" loading={isPending} disabled={isPending}>
        {deleteLabel}
      </Button>
    </DialogFooter>
  </Dialog>
);
